import React from 'react'
type GreetingTime = 'morning' | 'afternoon' | 'evening'

const Greeting: React.FC = () => {
  const getGreeting = (): string => {
    const hour = new Date().getHours()
    let timeOfDay: GreetingTime
    if (hour >= 5 && hour < 12) {
      timeOfDay = 'morning'
    } else if (hour >= 12 && hour < 19) {
      timeOfDay = 'afternoon'
    } else {
      timeOfDay = 'evening'
    }

    const greetings = {
      morning: 'Buenos días,',
      afternoon: 'Buenas tardes, ',
      evening: 'Buenas Noches, ',
    }

    return greetings[timeOfDay]
  }
  return <span className="hidden sm:inline">{getGreeting()}</span>
}

export default Greeting
